module.exports = __webpack_public_path__ + "assets/fonts/Gotham-UltraItalic.a8a84799.otf";